export default defineNuxtRouteMiddleware(() => {
  const userSession = useUserSession()

  if (!userSession.loggedIn) {
    return navigateTo('/')
  }
})
